module.exports = __webpack_public_path__ + "img/title_pc.ebb336b4.svg";